export default __webpack_public_path__ + "static/media/0x9246a5f10a79a5a939b0c2a75a3ad196aafdb43b.15d044d4.webp";